import React, { useState, useEffect } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import axios from "axios";
import { getLocalItem,removeLocalItem } from "./helper";
import { API_ENDPOINT_URL } from "./api";

const PrivateRoute = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCheckComplete, setIsCheckComplete] = useState(false);

  useEffect(() => {
    const token = getLocalItem("key");
    if (token) {
      axios
        .get(`${API_ENDPOINT_URL}/check-token-valid/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setIsLoggedIn(true);
          } else {
            localStorage.removeItem("key");
            setIsLoggedIn(false);
          }
        })
        .catch((error) => {
          localStorage.removeItem("key");
          setIsLoggedIn(false);
        })
        .finally(() => {
          setIsCheckComplete(true);
        });
    } else {
      setIsLoggedIn(false);
      setIsCheckComplete(true);
    }
  }, []);

  if (!isCheckComplete) {
    // return a loading indicator until the check is complete
    return <div>Loading...</div>;
  }
  return isLoggedIn ? children: <Navigate to="/login" />
};

export default PrivateRoute;